import React, { PropTypes } from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { Button } from 'react-bootstrap';
import TextareaControl from './../../FormTemplate/TextareaControl';

import RenderItemList from './FormHelper/RenderItemList';

class GainAdjustmentForm extends React.Component {
   render() {
      const { handleSubmit, saveGainAdjustment, items, submitting, pristine, invalid, error } = this.props;
      return (
         <form noValidate="true" autoComplete="off" onSubmit={handleSubmit(saveGainAdjustment)} >
            <FieldArray items={items} name="items" component={RenderItemList} />
            {error && <strong className="input-validation-error" >{error}</strong>}

            <Field name="memo" label="Memo" component={TextareaControl} />
            <Button type="submit" bsStyle="success" block
                    disabled={submitting || pristine || invalid} >Save</Button>
         </form>
      );
   }
}
GainAdjustmentForm.propTypes = {
   handleSubmit: PropTypes.func,
   saveGainAdjustment: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
   ])
};


GainAdjustmentForm = reduxForm({ // eslint-disable-line
   form: 'gainAdjustmentForm'
})(GainAdjustmentForm);


export default GainAdjustmentForm;



/** WEBPACK FOOTER **
 ** ./src/components/StockManagement/GainAdjustment/GainAdjustmentForm.js
 **/